export enum ProductTypeFormat {
  Uncovered,
  Rooftop,
  Indoor,
  Covered,
}
